module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/subject/subject.component.css
// module id = ./src/app/subject/subject.component.css
// module chunks = main